<template>
    <div class="window-wrapper window-client-check-subscribe-cancel">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Вы уверены, что хотите отменить подписку для всех писем Клиента, по которым не удается списать абонентскую плату?</div>
                    <div class="button-block">
                        <button @click="confirmCancel" class="button button-dark button-close-window">Да</button>
                        <button @click="closeWindow" class="button button-opacity button-close-window">Отмена</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SubscribeCancelWindow",
    methods: {
        confirmCancel() {
            this.$emit('confirmCancel');
            this.closeWindow();
        },
        closeWindow() {
            $('.window-client-check-subscribe-cancel').removeClass('window-open');
            $('body').removeClass('blocked');
        }
    }
}
</script>

<style scoped>

</style>